import { createFileRoute } from "@tanstack/react-router";
import { ExamListPage } from "@/components/exam-list/exam-list-page";
import { type ExamsSearch, examsSearchSchema } from "@/schemas/exams";

export const Route = createFileRoute("/_app/painel/listas-de-exercicio")({
	validateSearch: (search) => examsSearchSchema.parse(search || {}),
	component: ListasDeExercicioPage,
});

function ListasDeExercicioPage() {
	const search = Route.useSearch();
	const navigate = Route.useNavigate();

	return (
		<ExamListPage
			isExerciseList={true}
			search={search}
			onSearchChange={(updater: (old: ExamsSearch) => ExamsSearch) =>
				navigate({ search: updater })
			}
			onPageChange={(page: number) =>
				navigate({ search: (old: ExamsSearch) => ({ ...old, page }) })
			}
		/>
	);
}
